<div id="stickyParentWrapper" class="lobby_group--tabs-cotnainer">
    <div id="stickyWrapper" class="lobby_group--tabs-inner" 
        [ngClass]="windowType === 'mobile' ? 'sticky' : ''">
        <div class="lobby_header_bar">
            <div class="lobby_header--left">
                <app-lobby-tabs *ngIf="showTabsList" [categoryType]="categoryType" [lobbyDetails]="lobbyDetails" [currentGameGroupsList]="currentGameGroupsList">
                </app-lobby-tabs>

                <app-lobby-tabs *ngIf="!showTabsList" [skeltonLoader]="true" [currentGameGroupsList]="currentGameGroupsList"></app-lobby-tabs>
            </div>

            <div class="lobby_header--right">
                <app-slot-games-search class="hide-below-992"></app-slot-games-search>
                <!-- <div class="home_search-icon icon icon-search-1" (click)="showSearchBar()"></div> -->
                <div class="lobby_header--filter-group hidden-xs hidden-sm">
                    <app-lobby-filters [gameProviderMap]="gameProviderMap"></app-lobby-filters>
                    <!-- <app-lobby-sorting></app-lobby-sorting> -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Games Search Bar -->
<app-search-sticky-bar></app-search-sticky-bar>